import { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import { Skeleton } from "@mui/material";
import { getDataFromCmsApi } from "../../api/contentful-service";
import "./homepage-banner.scss";

const speed = 10000;

function HomepageBanners() {
    const [homepageBanners, setHomepageBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const result = await getDataFromCmsApi("Collection/Homepage Banners");
        setHomepageBanners(result);
        setLoading(false);
    };

    return (
        <div className="homepage-banners-section">
            <Carousel>
                {loading
                    ? Array.from({ length: 1 }).map((_, i) => (
                          <div key={i}>
                              <Skeleton animation="wave" variant="rectangular" width="100%" height={"30vh"} />
                          </div>
                      ))
                    : homepageBanners?.items?.map((item, i) => (
                          <div key={i} interval={speed}>
                              <a
                                  href={item.link !== "" ? item.link : null}
                                  target="_blank"
                                  rel="noreferrer"
                                  title={item.link}>
                                  <img
                                      className="card-img"
                                      src={`https:${item.bannerImageUrl}`}
                                      alt={item.title}
                                  />
                              </a>
                          </div>
                      ))}
            </Carousel>
        </div>
    );
}

export default HomepageBanners;
